import { API, graphqlOperation } from 'aws-amplify';

export default {
    namespaced:true,
    state: {
        dlist: null,
        clist: null,
        rclist: null,
        dnextToken: null,
        cnextToken: null,
    },
    mutations: {
        dlist: (state, payload) => { state.dlist = payload.append ? (state.dlist || []).concat(payload.value) : payload.value },
        clist: (state, payload) => { state.clist = payload.append ? (state.clist || []).concat(payload.value) : payload.value },
        rclist: (state, payload) => { state.rclist = payload.append ? (state.rclist || []).concat(payload.value) : payload.value },
        dnextToken: (state, payload) => { state.dnextToken = payload.value },
        cnextToken: (state, payload) => { state.dnextToken = payload.value }
    },
    getters: {
    },
    actions: {
        async list(context) {
          await  Promise.all([context.dispatch('clist'),context.dispatch('dlist')]);
        },
        async dlist(context, payload) {
          var filter =  payload?.companyId ? { companyID: { eq : payload.companyId } } : null;
          //console.dir(filter);
          const c = await API.graphql(graphqlOperation(`
            query ListDomains(
              $filter: ModelDomainFilterInput
              $limit: Int
              $nextToken: String
            ) {
              listDomains(filter: $filter, limit: $limit, nextToken: $nextToken) {
                items {
                  id
                  createdAt
                  name
                  platform
                  productsUpdated
                  leadscoresUpdated
                  eventsPurged
                  recommendationsUpdated
                  bounces
                  complaints
                  active
                  companyID
                  stats {
                    monthlyUsers
                    products
                    dreamroiSales
                    emailsSent
                  }
                  capabilities {
                    allow
                    feed
                    tracker
                    viewProduct
                    signIn
                    purchase
                    #showBox
                    addToCart
                    dkim
                    spf
                    linkDomain
                    #orders
                  }
                  ordersImported
                  contactsImported
                  totalEmailRecipients
                }
                nextToken
              }
            }
          `, { filter, nextToken: payload?.nextToken }));
            context.commit('dlist', {value: c.data.listDomains.items, append: !!payload?.nextToken });
            context.commit('dnextToken', {value: c.data.listDomains.nextToken });
            if(context.state.dnextToken) {
                await context.dispatch('dlist', { nextToken: context.state.dnextToken });
            }
        },

        async clist(context, payload) {
          var filter =  null;
          //console.dir(filter);
          const c = await API.graphql(graphqlOperation(`
            query ListCompanies(
              $filter: ModelCompanyFilterInput
              $limit: Int
              $nextToken: String
            ) {
              listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
                items {
                  id
                  email
                  phone
                  name
                  active
                  activeSubscription {
                    from
                    to
                    monthlyUserLimit
                  }
                  stats {
                    monthlyUsers
                    dreamroiSales
                    emailsSent
                  }
                  hasManualInvoicing
                  hasStripeSubscription
                }
                nextToken
              }
            }
          `, { filter, nextToken: payload?.nextToken }));
            context.commit('clist', {value: c.data.listCompanys.items, append: !!payload?.nextToken });
            context.commit('cnextToken', {value: c.data.listCompanys.nextToken });
            if(context.state.cnextToken) {
                await context.dispatch('clist', { nextToken: context.state.cnextToken });
            }
        },

        async getBillingHistory(context, payload) {
          const c = await API.graphql(graphqlOperation(`query GetCompany($id: ID!) {
            getCompany(id: $id) {
              history {
                subscription {
                  from
                  to
                  monthlyUserLimit
                }
                stats {
                  monthlyUsers
                  dreamroiSales
                  emailsSent
                }
              }
            }
          }`, { id: payload.id}));
          return c.data.getCompany.history;
        },

        async updateDomain(context, payload) {
          await API.graphql(graphqlOperation(`
            mutation UpdateDomain(
              $input: UpdateDomainInput!
              $condition: ModelDomainConditionInput
            ) {
              updateDomain(input: $input, condition: $condition) {
                id
              }
            }
          `, { input: payload }));
          //return context.dispatch('list');
          //return r.data.updateDomain;
        },

        async updateCompany(context, payload) {
            await API.graphql(graphqlOperation(`
              mutation UpdateCompany(
                $input: UpdateCompanyInput!
                $condition: ModelCompanyConditionInput
              ) {
                updateCompany(input: $input, condition: $condition) {
                  id
                }
              }
            `, { input: payload }));
            //return context.dispatch('list');
            //return r.data.updateDomain;
        },

        async getRunningCampaigns(context, payload) {
          let q = /* GraphQL */ `
          query RunningCampaigns($nextToken: String, $scheduleType: CamapaignScheduleType!, $state: String) {
            campaignsByScheduleTypeState(limit: 1000, nextToken: $nextToken, scheduleType: $scheduleType, state: {eq: $state}) {
              nextToken
              items {
                id
                schedule
                scheduleType
                name
                domain {
                  id
                  companyID
                  name
                }
                state
                dailyStats(limit: 1, sortDirection: DESC) {
                  items {
                    sent
                    date
                  }
                }
                messages(limit: 1, sortDirection: DESC) {
                  items {
                    sent
                    visitor {
                      email
                    }
                    email
                  }
                }
              }
            }
          }
          `;
          let append = !!payload?.queries || payload?.append;
          let queries = payload?.queries ?? {
            'SCHEDULED': null,
            'AUTOMATIC': null,
            'BACK_TO_CART': null,
            'SMART_WARM_UP': null,
            'WELCOME': null
          };
          let promises = Object.entries(queries).map(([scheduleType, nextToken]) => API.graphql(graphqlOperation(q, { scheduleType, nextToken, state: payload?.state ?? 'SENDING' })));
          let results = await Promise.all(promises);

          let qarr = Object.keys(queries);
          let nq = false;
          results.forEach((r,i) => { 
            nq = nq || r.data.campaignsByScheduleTypeState.nextToken; 
            queries[qarr[i]] = r.data.campaignsByScheduleTypeState.nextToken; 
            context.commit('rclist', {value: r.data.campaignsByScheduleTypeState.items, append: append || i > 0 });
          });
          if(nq) {
            /*eslint-disable no-unused-vars*/
            await context.dispatch('getRunningCampaigns', { queries: Object.fromEntries(Object.entries(queries).filter(([_k,v]) => !!v)), state: payload?.state });
            /*eslint-enable no-unused-vars */
          }
        }
    }
}